import styles from '@components/components/CmsComponents/components/CoreQuote/CoreQuote.module.scss';
import React from 'react';
import { Heading } from '@wienenergiegithub/ui-next';

const CoreQuote = ({ value, citation }) => (
  <div className={styles.container}>
    <blockquote className={styles.quote}>
      <Heading as="div" size="h5">
        {value}
      </Heading>
      <footer className={styles.footer}>{citation}</footer>
    </blockquote>
  </div>
);

export default CoreQuote;
